/**
 * Created by Kieran on 01/10/2017.
 *
 * Javascript component importing interface
 *
 * Exports components that's mainly used to create Health Tracking graph
 * Allows you to import like this:
 * import {LineGraph, BarGraph} from '../../../Graph
 *
 * Make sure you add to component's component list
 *
 * components: {
 *    LineGraph,
 *    BarGraph
 * }
 *
 */

import LineGraph from './Line/index';
import BarGraph from './Bar/index'


export {
  LineGraph,
  BarGraph
};









// WEBPACK FOOTER //
// ./src/components/Tracking/Graph/index.js